import Vue from 'vue'
import Component from 'vue-class-component'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

@Component({
  name: 'loading-indicator',
  props: ['fullPage'],
  components: {
    Loading
  }
})
export default class LoadingIndicator extends Vue {
  get isFullPage(): boolean {
    return this.$props['fullPage']
  }
}
